export const flowWechatServiceFollowZH = {
  wechatServiceFollowPayKicker: '微信服务通知 · 未关注可能错过重要通知',
  wechatServiceFollowPayTitlePrefix: '关注 ',
  wechatServiceFollowPayTitleEm: 'WeBloom 公众号',
  wechatServiceFollowPayTitleSuffix: '',
  wechatServiceFollowPayTitleSub: '未关注可能错过重要通知，影响后续参与',
  wechatServiceFollowPayDesc: '接下来该活动的日程变更、任务截止、组队等关键信息，将通过微信公众号同步给你。请及时关注，以免错过重要通知、影响后续参与。',
  wechatServiceFollowQrScan: '微信扫一扫',
  wechatServiceFollowQrCaption: '扫码1秒关注',
  wechatServiceFollowQrFollow: '关注公众号',
  wechatServiceFollowConflictNotice: '上次关注使用的微信，已在为其他 BLOOM 账号接收提醒，请更换微信重新关注。',
  wechatServiceFollowUnavailablePay: '暂时无法开启微信服务提醒，请稍后再试。支付结果不受影响。',
  wechatServiceFollowUnavailableProfile: '暂时无法开启微信服务提醒，请稍后再试。当前页面的其他功能不受影响。',
  wechatServiceFollowUnavailableTitle: '后续通知服务暂未开启',
  wechatServiceFollowQrExpired: '二维码已过期',
  wechatServiceFollowRefreshQr: '刷新二维码',
  wechatServiceFollowSectionTitle: '微信服务号',
  wechatServiceFollowProfileKicker: '微信服务通知 · 未关注可能错过重要通知',
  wechatServiceFollowProfileTitlePrefix: '关注 ',
  wechatServiceFollowProfileTitleEm: 'WeBloom 公众号',
  wechatServiceFollowProfileTitleSuffix: '',
  wechatServiceFollowProfileTitleSub: '未关注可能错过重要通知，影响后续参与',
  wechatServiceFollowProfileDesc: '活动的日程变更、任务截止、组队等关键信息，将通过微信公众号同步给你。请及时关注，以免错过重要通知、影响后续参与。',
  wechatServiceFollowBenefitSchedule: '活动日程自动提醒',
  wechatServiceFollowBenefitDeadline: '任务截止微信直达',
  wechatServiceFollowBenefitTeam: '组队信息及时通知'
}

export const flowWechatServiceFollowEN = {
  wechatServiceFollowPayKicker: 'WeChat service notices · You may miss important notices if you do not follow',
  wechatServiceFollowPayTitlePrefix: 'Follow the ',
  wechatServiceFollowPayTitleEm: 'WeBloom official account',
  wechatServiceFollowPayTitleSuffix: '',
  wechatServiceFollowPayTitleSub: 'You may miss important notices and affect later participation',
  wechatServiceFollowPayDesc: 'Schedule changes, task deadlines, team updates and other key information for this activity will be synced to you via the WeChat official account. Please follow in time so you do not miss important notices or affect later participation.',
  wechatServiceFollowQrScan: 'Scan with WeChat',
  wechatServiceFollowQrCaption: 'Scan to follow in 1 second',
  wechatServiceFollowQrFollow: 'Follow the official account',
  wechatServiceFollowConflictNotice: 'The WeChat used last time is already receiving reminders for another BLOOM account. Please follow again with a different WeChat.',
  wechatServiceFollowUnavailablePay: 'Unable to enable WeChat service reminders right now. Please try again later. Your payment result is not affected.',
  wechatServiceFollowUnavailableProfile: 'Unable to enable WeChat service reminders right now. Please try again later. Other functions on this page are not affected.',
  wechatServiceFollowUnavailableTitle: 'Later notice service is not enabled yet',
  wechatServiceFollowQrExpired: 'QR code expired',
  wechatServiceFollowRefreshQr: 'Refresh QR code',
  wechatServiceFollowSectionTitle: 'WeChat Official Account',
  wechatServiceFollowProfileKicker: 'WeChat service notices · You may miss important notices if you do not follow',
  wechatServiceFollowProfileTitlePrefix: 'Follow the ',
  wechatServiceFollowProfileTitleEm: 'WeBloom official account',
  wechatServiceFollowProfileTitleSuffix: '',
  wechatServiceFollowProfileTitleSub: 'You may miss important notices and affect later participation',
  wechatServiceFollowProfileDesc: 'Schedule changes, task deadlines, team updates and other key information for activities will be synced to you via the WeChat official account. Please follow in time so you do not miss important notices or affect later participation.',
  wechatServiceFollowBenefitSchedule: 'Automatic activity schedule reminders',
  wechatServiceFollowBenefitDeadline: 'Task deadlines delivered in WeChat',
  wechatServiceFollowBenefitTeam: 'Team updates in time'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/wechatServiceFollow.js